import React from 'react';
import { Button, Col, Row } from 'antd';
import { useHistory } from 'react-router';
import { PageLayout } from '@BUP/components';
import './styles.css';

const SociogramFinishedPage = () => {
  const history = useHistory();
  const backToBeginning = async () => {
    history.push('/data');
  };

  return (
    <PageLayout>
      <Row>
        <Col className="finishedPage_text-wrapper" span={24}>
          <h1 className="finishedPage_title">¡Haz terminado!</h1>
          <b className="finishedPage_text">
            ¡Muchas gracias por tu participación!
          </b>
          <p>Tu encuesta ha sido enviada</p>
          <Button onClick={backToBeginning} type="primary">
            <b>Volver a inicio</b>
          </Button>
        </Col>
      </Row>
    </PageLayout>
  );
};

export default SociogramFinishedPage;
